import { luaScript, getQuery, postToServer } from '../../helpers/helper_store';
import i18n from '@/locales';
function resetCheckboxes(json) {
	for (let key in json) {
		if (json.hasOwnProperty(key) && typeof json[key] === 'object') {
			if (!Array.isArray(json[key])) {
				json[key].checked = false;
			}
			resetCheckboxes(json[key]);
		}
	}
}
function findChecked(array, json) {
	for (let key in json) {
		if (json.hasOwnProperty(key) && typeof json[key] === 'object') {
			if (!!json[key].checked && json[key].properties.type !== 'server') {
				array.push([ json[key].properties.serverid, json[key].properties.id, json[key].text ]);
			}
			findChecked(array, json[key]);
		}
	}
}

function addIfNotExists(array, qTasks) {
	for (let t = 0; t < qTasks.length; t++) {
		const qId = qTasks[t].qId;
		const pid = qTasks[t].pid;
		let flag = 0;
		for (let i = 0; i < array.length; i++) {
			if (array[i].qId === qId && array[i].pid === pid) {
				// если совпало и не нужно обновлять pid
				flag++;
				break;
			}
		}
		if (flag === 0) array.push(qTasks[t]);
	}
}

const state = {
	multitree: null,
	upgTasks: null,
	taskId: null,
	checkedArray: [],
	showCheckboxes: false,
	cmdlineArray: [],
	startedQueueIds: [],
	finishedQueueIds: [],
	errorQueueIds: []
};
const mutations = {
	setMultiTree(state, data) {
		state.multitree = data;
	},
	setUpgTasks: (state, data) => (state.upgTasks = Array.isArray(data) ? data : [ data ]),
	setTaskId: (state, data) => (state.taskId = data),
	setShowCheckboxes: (state, data) => (state.showCheckboxes = data),
	applyPreset(state, preset) {
		// console.log('preset', preset);
		resetCheckboxes(state.multitree);
		for (let pr of preset) {
			// console.log(pr);
			// let id = pr.id; //[1, 35]
			let serverId = pr[0];
			let appId = pr[1];
			let server = state.multitree.find((server) => server.properties.id === serverId);
			if (!server) {
				this.state.login.error = i18n.t("multiTask.presetElementNotFound");
				return;
			}
			// console.log('server', server.children[1]);
			let app = server.children.find((app) => app.properties.id === appId);
			if (!app) {
				this.state.login.error = i18n.t("multiTask.presetElementNotFound");
				return;
			}
			app.checked = true;
		}
	},
	uncheckTree(state) {
		resetCheckboxes(state.multitree);
	},
	setCheckedArray(state) {
		state.checkedArray = [];
		findChecked(state.checkedArray, state.multitree);
	},
	initStartedQueueIds: (state, data) => {
		let array = [];
		data.forEach((id, index) => {
			array.push({ appName: state.checkedArray[index][2], qId: id, pid: null });
		});
		state.startedQueueIds = array;
	},
	updateStartedQueueIds: (state, data) => (state.startedQueueIds = data),
	updateFinishedQueueIds: (state, data) => addIfNotExists(state.finishedQueueIds, data),
	updateErrorQueueIds: (state, data) => addIfNotExists(state.errorQueueIds, data)
};

const actions = {
	getUpgTree({ rootState, commit }, fileName) {
		return new Promise((resolve, reject) => {
			luaScript('multirunupg', 'tree', { upg: fileName }, rootState.login)
				.then((result) => {
					commit('setMultiTree', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getUpgTasks({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getUpgTasks', null, rootState.login)
				.then((result) => {
					commit('setUpgTasks', result);
					resolve();
				})
				.catch(() => reject());
		});
	},
	runMultiUpg({ rootState, commit }, formData) {
		return new Promise((resolve, reject) => {
			postToServer(formData, rootState.login)
				.then((result) => {
					if (result.busy.length > 0) {
						//show message and go back to checked tree
						reject({ clean: result.clean, busy: result.busy });
					}
					commit('initStartedQueueIds', result.run);
					resolve({ clean: result.clean });
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateMultiStatus({ rootState, commit, state }) {
		let count = 0;
		return new Promise((resolve, reject) => {
			setTimeout(function run() {
				if (state.startedQueueIds.length === 0) {
					resolve();
					return;
				}
				let queryParamArray = [];
				state.startedQueueIds.forEach((qTask) => {
					queryParamArray.push(qTask.qId);
				});
				const queryParam = queryParamArray.join(',');
				getQuery('getMultipleTaskStatus', queryParam, rootState.login)
					.then((result) => {
						let arrayResult = Array.isArray(result) ? result : [ result ];
						if (arrayResult.length === 0) {
							commit('setError', i18n.t('multiTask.noSuchTasks'));
							reject();
							return;
						}
						let started = [];
						let finished = [];
						let error = [];
						for (let i = 0; i < state.startedQueueIds.length; i++) {
							let statusInfo = arrayResult[i];
							let qTask = state.startedQueueIds[i];
							if (statusInfo.statusTask === '1') {
								started.push({ ...qTask, pid: statusInfo.pid });
							} else if (statusInfo.statusTask === '2') {
								if (statusInfo.result === 'OK') {
									finished.push({ ...qTask, pid: statusInfo.pid });
								} else error.push({ ...qTask, pid: statusInfo.pid });
							}
						}
						count++;
						commit('updateStartedQueueIds', started);
						commit('updateFinishedQueueIds', finished);
						commit('updateErrorQueueIds', error);
						if (started.length === 0) {
							resolve();
						}
						if (count >= 1000) {
							commit('setError', i18n.t('multiTask.tooLongOperation'));
							reject();
							return;
						} else setTimeout(run, 4000);
					})
					.catch((error) => {
						commit('setError', error);
						reject();
					});
			});
		});
	}
};

const getters = {
	multitree: (state) => state.multitree,
	upgTasks: (state) => state.upgTasks,
	checkedArray: (state) => state.checkedArray,
	showCheckboxes: (state) => state.showCheckboxes,
	selectedTaskId: (state) => state.taskId,
	startedQueueIds: (state) => state.startedQueueIds,
	finishedQueueIds: (state) => state.finishedQueueIds,
	errorQueueIds: (state) => state.errorQueueIds
};

export default {
	state,
	mutations,
	actions,
	getters
};
